"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].AmpContext;

//# sourceMappingURL=amp-context.js.map